import { Controller } from 'stimulus';

export default class KeywordExclusionsController extends Controller {
  static targets = ['keywordExclusionForm']

  submitForm() {
    Rails.fire(this.keywordExclusionFormTarget, 'submit');
  }
}
